import * as icons from '@assets/icons';
import * as serviceStatusIcons from '@assets/icons/serviceStatus';
import * as floorPlanIcons from '@assets/icons/floorPlan';

const ALL_ICONS = {
  ...icons,
  ...floorPlanIcons,
  ...serviceStatusIcons,
} as const;

export const IconComponents = Object.fromEntries(
  Object.entries(ALL_ICONS).map(([key, value]) => [key, value]),
) as {
  [K in keyof typeof ALL_ICONS]: (typeof ALL_ICONS)[K];
};
